import styles from "./Updates.module.css";

function Updates({ updates, popupSelected }) {
  return (
    <div className={styles.section}>
      <h1>Próximas atualizações {popupSelected}</h1>
      {Object.entries(updates[popupSelected]).map(([step, infos]) => (
        <>
          <h2>{step}</h2>
          <div className={styles.separator}></div>
          <img
            className={styles.tutorialImage}
            src={require("../utils/img/" + infos["image"])}
            alt={step}
          />
          {infos.description.map((desc, index) => (
            <p>{desc}</p>
          ))}
        </>
      ))}
    </div>
  );
}

export default Updates;
